import { useEffect, useState } from "react";
import reportApi from "../../../../../api/reportApi";

/**
 * Fetch pipeline report. Cancellation via `cancelled` flag guards against
 * race conditions on rapid filter changes. `reloadKey` is bumped externally
 * (e.g. after stages are edited) to force a re-fetch.
 */
export function usePipelineReport({
  shopId,
  accountId,
  from,
  to,
  compareFrom,
  compareTo,
  compareEnabled,
  reloadKey = 0,
}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selfReload, setSelfReload] = useState(0);

  useEffect(() => {
    if (!shopId || !accountId || !from || !to) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setData(null);
    setError(null);

    const params = {
      shopId,
      accountId,
      from,
      to,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    if (compareEnabled && compareFrom && compareTo) {
      params.compareFrom = compareFrom;
      params.compareTo = compareTo;
    }

    reportApi
      .getPipeline(params)
      .then((res) => {
        if (cancelled) return;
        if (res.status === 1) {
          setData(res.data);
        } else {
          setData(null);
          setError(res.message || "Không tải được dữ liệu");
        }
      })
      .catch((err) => {
        if (cancelled) return;
        setData(null);
        setError(err.message);
      })
      .finally(() => !cancelled && setLoading(false));

    return () => {
      cancelled = true;
    };
  }, [
    shopId,
    accountId,
    from,
    to,
    compareFrom,
    compareTo,
    compareEnabled,
    reloadKey,
    selfReload,
  ]);

  return {
    data,
    loading,
    error,
    refetch: () => setSelfReload((n) => n + 1),
  };
}
